<template>
  <f7-page name="ua-take-photo" id="ua-take-photo" class="bg-color-white" @page:afterin="afterin">
    <f7-navbar class="view-mobile">
      <f7-nav-left class="back-button">
        <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
      </f7-nav-left>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-block>
      <ul class="step-nav">
        <li :class="[{active: (currentStep >= EkycStep.FRONT_DOC_PHOTO)}]"></li>
        <li :class="[{active: (currentStep >= EkycStep.SELFIE_PHOTO)}]"></li>
        <li :class="[{active: (currentStep >= EkycStep.POA_PHOTO)}]" v-if="isNeedPOA"></li>
        <li v-if="isFromHome"></li>
      </ul>
      <p class="text-color-gray">{{ ekycTitle }}</p>
      <f7-list-input v-show="false" @change="loadImageFromFile($event)" input-id="uploadPhoto" accept="image/*" type="file"></f7-list-input>
    </f7-block>

    <!-- [START] Image Picker -->
    <f7-block v-if="currentStep != EkycStep.NONE && ekycImageData == ''" :class="[{selfie: (currentStep == EkycStep.SELFIE_PHOTO), docs: (currentStep != EkycStep.SELFIE_PHOTO), poa: (currentStep == EkycStep.POA_PHOTO)}]" class="mt-xxl">
      <f7-row>
        <div class="main-ekyc-guide clickable-item" @click="openCamera()">
          <img class="main-image" v-show="isGuideImgLoaded" :src="guideImgName == '' || guideImgName.length < 1 ? '' : require('@/assets/img/ekyc/' + guideImgName + '.svg')" @load="onGuideImgLoaded" />
          <img class="fullWidth frame" :src="require('@/assets/img/ekyc/ekyc_frame' + (currentStep == EkycStep.SELFIE_PHOTO?'_square':'') + '.svg')" />
          <img class="fullWidth checkmark" :src="require('@/assets/img/ekyc/ic_green_checkmark.svg')" />
        </div>
      </f7-row>
      <f7-row class="ekyc-guides-wrong mt-xxl">
        <f7-col class="ekyc-blur clickable-item" @click="openCamera()">
          <div class="fullWidth">
            <img v-show="isGuideImgLoaded" :src="guideImgName == '' || guideImgName.length < 1 ? '' : require('@/assets/img/ekyc/' + guideImgName + '.svg')" />
          </div>
          <img class="fullWidth wrong-icon" :src="require('@/assets/img/ekyc/ic_red_wrong.svg')" />
        </f7-col>
        <f7-col class="ekyc-crop clickable-item" @click="openCamera()">
          <div class="fullWidth">
            <img v-show="isGuideImgLoaded" :src="guideImgName == '' || guideImgName.length < 1 ? '' : require('@/assets/img/ekyc/' + guideImgName + '.svg')" />
          </div>
          <img class="fullWidth wrong-icon" :src="require('@/assets/img/ekyc/ic_red_wrong.svg')"/>
        </f7-col>
        <f7-col class="ekyc-flash clickable-item" @click="openCamera()">
          <div class="fullWidth">
            <img v-show="isGuideImgLoaded" :src="guideImgName == '' || guideImgName.length < 1 ? '' : require('@/assets/img/ekyc/' + guideImgName + '.svg')" />
            <img class="flash-icon" :src="require('@/assets/img/ekyc/ic_flash.svg')"/>
          </div>
          <img class="fullWidth wrong-icon" :src="require('@/assets/img/ekyc/ic_red_wrong.svg')"/>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-block class="footer" v-if="currentStep != EkycStep.NONE && ekycImageData == ''">
      <div class="text-align-center display-flex justify-content-space-between">
        <f7-button large fill class="w-100" @click="choosePhoto" :disabled="(currentStep == EkycStep.NONE)?true:false">
          <img :src="require('@/assets/img/icon/icon-choose-image.svg')" class="me-1 p-0" style="width:15px"/> {{$t('account-verify-choose-image')}}
        </f7-button>
        <f7-button v-if="isMobile" large fill class="w-100 ms-2" @click="openCamera" :disabled="(currentStep == EkycStep.NONE)?true:false">
          <img :src="require('@/assets/img/icon/icon-take-picture.svg')" class="me-1 p-0" style="width:18px"/> {{$t('account-verify-take-picture')}}
        </f7-button>
      </div>
      <f7-button class="mt-md" large outline @click="skipTheStep">
        {{ $t('general-text-skip') }}
      </f7-button>
    </f7-block>
    <!-- [END] Image Picker -->

    <!-- [START] Image Preview -->
    <f7-block v-if="currentStep != EkycStep.NONE && ekycImageData != ''" class="text-center">
      <img class="image-preview" :src="ekycImageData" style="max-width: 100%;" />
    </f7-block>
    <f7-block class="footer" v-if="currentStep != EkycStep.NONE && ekycImageData != ''">
      <f7-button large fill @click="confirmEkycImage" :disabled="(currentStep == EkycStep.NONE)?true:false">
          {{$t('general-text-upload')}}
      </f7-button>
      <f7-button class="mt-md" large outline @click="retakeImage">
        {{ isChooseFromGallery ? $t('account-verify-back-gallery') : $t('account-verify-retake-picture') }}
      </f7-button>
    </f7-block>
    <!-- [END] Image Preview -->
  </f7-page>
</template>

<style>
/* General */
#ua-take-photo .main-ekyc-guide { position: relative; width: 100%; background-color: #FAFAFA; border-radius: 5px; font-size: 0px; padding: 7% 0; margin-bottom: 11px; text-align: center; }
#ua-take-photo .main-ekyc-guide img.frame { width: 67%; height: auto; }
#ua-take-photo .main-ekyc-guide img.main-image { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: auto; }
#ua-take-photo .main-ekyc-guide img.checkmark { position: absolute; width: 100%; height: 22px; top: calc(100% - 11px); left: 0; }

#ua-take-photo .ekyc-guides-wrong { padding-bottom: 11px; margin-bottom: 38px; }
#ua-take-photo .ekyc-guides-wrong .col { position: relative; height: 0; padding-top: 22%; background-color: #FAFAFA; border-radius: 5px; font-size: 0px; }
#ua-take-photo .ekyc-guides-wrong .col div.fullWidth { overflow:hidden; height: 100%; position: absolute; width: 100%; top: 0; bottom: 0; }
#ua-take-photo .ekyc-guides-wrong .col img.wrong-icon { position: absolute; height: 22px; top: calc(100% - 11px); left: 50%; transform: translateX(-50%); }

#ua-take-photo .ekyc-guides-wrong .col.ekyc-blur div.fullWidth { filter: blur(5px); }

.ekyc-animate-left{position:relative;animation:animateleft 0.4s}@keyframes animateleft{from{left:-300px;opacity:0} to{left:0;opacity:1}}
.ekyc-animate-right{position:relative;animation:animateright 0.4s}@keyframes animateright{from{right:-300px;opacity:0} to{right:0;opacity:1}}
/* #ua-take-photo .footer{ position: absolute; bottom: 24px; left: 0; right: 0; } */


/* Docs */

#ua-take-photo .docs .main-ekyc-guide img.main-image { width: 58%; }

#ua-take-photo .docs .ekyc-guides-wrong .col.ekyc-blur div.fullWidth img,
#ua-take-photo .docs .ekyc-guides-wrong .col.ekyc-crop div.fullWidth img,
#ua-take-photo .docs .ekyc-guides-wrong .col.ekyc-flash div.fullWidth img
{ width: 65%; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: auto; }

#ua-take-photo .docs .ekyc-guides-wrong .col.ekyc-crop div.fullWidth img { top: -5px; height: auto; transform: translateX(-50%) rotate(-15deg); }
#ua-take-photo .docs .ekyc-guides-wrong .col.ekyc-flash div.fullWidth img.flash-icon { position: absolute; top: 50%; left: 25%; width: 20%; }


/* Selfie */

#ua-take-photo .selfie .main-ekyc-guide img.main-image { height: 72%; }

#ua-take-photo .selfie .ekyc-guides-wrong .col.ekyc-blur div.fullWidth img,
#ua-take-photo .selfie .ekyc-guides-wrong .col.ekyc-flash div.fullWidth
{ width: auto; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: 70%; }

#ua-take-photo .selfie .ekyc-guides-wrong .col.ekyc-crop div.fullWidth img { position: absolute; right: -46%; top: 50%; transform: translate(-50%, -50%); height: 70%; }
#ua-take-photo .selfie .ekyc-guides-wrong .col.ekyc-flash div.fullWidth img.flash-icon { position: absolute; top: 15%; right: 20%; width: 40%; height: auto; }
#ua-take-photo .selfie .ekyc-guides-wrong .col.ekyc-flash div.fullWidth img:first-child { height: 100%; }


/* POA */

#ua-take-photo .poa .main-ekyc-guide img.main-image { width: 70%; }

#ua-take-photo .poa .ekyc-guides-wrong .col.ekyc-blur div.fullWidth img,
#ua-take-photo .poa .ekyc-guides-wrong .col.ekyc-crop div.fullWidth img,
#ua-take-photo .poa .ekyc-guides-wrong .col.ekyc-flash div.fullWidth img { width: 95%; }

@media (min-width: 768px) {
  #ua-take-photo .main-ekyc-guide img.checkmark,
  #ua-take-photo .ekyc-guides-wrong .col img.wrong-icon {
    height: 40px;
    top: calc(100% - 20px);
  }
  #ua-take-photo .main-ekyc-guide {
    margin-bottom: 20px;
  }
  #ua-take-photo .ekyc-guides-wrong {
    padding-bottom: 20px;
  }
}
</style>

<script>
  import { mapGetters, mapActions } from "vuex";

  const EkycStep = { NONE: 0, FRONT_DOC_PHOTO: 1, BACK_DOC_PHOTO: 2, SELFIE_PHOTO: 3, POA_PHOTO: 4 };
  export default {
    data() {
      return {
        EkycStep,
        currentStep: EkycStep.NONE,
        ekycList: [],
        ekycTitle: "",
        ekycImageData: "",
        guideImgName: "",
        isGuideImgLoaded: false,
        isNeedSelfie: true,
        isNeedPOA: true,
        isChooseFromGallery: false,
        isMobile: false,
      }
    },
    props: {
      doc: Object,
      isFromHome: Boolean,
      isFromMyInfo: Boolean
    },

    mounted() {
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      if(window.Android || window.webkit) {
        window.getEKYCImageData = this.getEKYCImageData;
        this.isMobile = true;
      }

      if(this.doc == '' || this.doc == undefined) {
        this.currentStep = EkycStep.NONE;
        return;
      }
      else if(this.doc.id == process.env.VUE_APP_DOCUMENT_ID_POA) {
        this.isNeedPOA = true;
        this.currentStep = EkycStep.POA_PHOTO;
      }
      else {
        if(this.doc.id == process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID)
          this.isNeedPOA = false; // No need to Take POA Photo for NRIC Docs

        this.currentStep = EkycStep.FRONT_DOC_PHOTO;
      }

      this.loadEkycDetail();
    },

    destroyed() {
      if (window.getEKYCImageData) window.getEKYCImageData = null;
    },

    methods: {
        ...mapActions('auth', ['login']),
        ...mapActions('ekycService', ['uploadEkycDocs']),
        ...mapActions('customer', ['setUpdateIdType']),

        afterin(){
          window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        },
        docId() {
          return (this.currentStep == EkycStep.SELFIE_PHOTO) ? process.env.VUE_APP_DOCUMENT_ID_SELFIE : ((this.currentStep == EkycStep.POA_PHOTO) ? process.env.VUE_APP_DOCUMENT_ID_POA : Number(this.doc.id));
        },
        onGuideImgLoaded () {
          this.isGuideImgLoaded = true;
        },
        getDocImageList(docId) {
          const self = this;
          return self.ekycList.filter(ekyc => ekyc.id == docId && ekyc.image != "").map(ekyc => ekyc.image);
        },
        showPrevSlideAnimation() {
          this.Dom7('#ua-take-photo .page-content').addClass('ekyc-animate-left');
          setTimeout(() => {
            this.Dom7('#ua-take-photo .page-content').removeClass('ekyc-animate-left');
          }, 400)
        },
        showNextSlideAnimation() {
          this.Dom7('#ua-take-photo .page-content').addClass('ekyc-animate-right');
          setTimeout(() => {
            this.Dom7('#ua-take-photo .page-content').removeClass('ekyc-animate-right');
          }, 400)
        },

        loadEkycDetail() {
          if(this.currentStep == EkycStep.FRONT_DOC_PHOTO) {
            this.ekycTitle = this.$t('ua-take-front-docs');
            this.guideImgName = (this.doc.id == process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID ? this.doc.id : 103)+'_doc_front';
          }
          else if(this.currentStep == EkycStep.BACK_DOC_PHOTO) {
            this.ekycTitle = this.$t('ua-take-back-docs');
            this.guideImgName = (this.doc.id == process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID ? this.doc.id : 103)+'_doc_back';
          }
          else if(this.currentStep == EkycStep.SELFIE_PHOTO) {
            this.ekycTitle = this.$t('ua-take-selfie');
            this.guideImgName = 'ekyc_doc_selfie';
          }
          else if(this.currentStep == EkycStep.POA_PHOTO) {
            this.ekycTitle = this.$t('ua-take-poa');
            this.guideImgName = 'ekyc_doc_poa_2';
          }

          if(this.ekycList.length < 1 || this.ekycList.filter(ekyc => ekyc.id == this.docId() && ekyc.stepId == this.currentStep).length < 1)
            this.ekycList.push({ id: this.docId(), stepId: this.currentStep, image: "" });
        },
        async resizeImage(base64Str, maxWidth = 1204, maxHeight = 1204) {
          return new Promise((resolve) => {
            let img = new Image()
            img.src = base64Str
            img.onload = () => {
              let canvas = document.createElement('canvas')
              const MAX_WIDTH = maxWidth
              const MAX_HEIGHT = maxHeight
              let width = img.width
              let height = img.height

              if (width > height) {
                if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width
                  width = MAX_WIDTH
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height
                  height = MAX_HEIGHT
                }
              }
              canvas.width = width
              canvas.height = height
              let ctx = canvas.getContext('2d')
              ctx.drawImage(img, 0, 0, width, height)
              resolve(canvas.toDataURL())
            }
          })
        },
        getEKYCImageData(imageData, isChooseFromGallery) {
          const self = this;
          self.showPreloader();
          self.isChooseFromGallery = isChooseFromGallery;
          if(!imageData.includes("base64"))
            imageData = 'data:image/png;base64,'+imageData;

          setTimeout(() => {
            // Get Image Size
            const imgBase64Str = imageData.replace(/data:image\/.*base64,/gi, "");
            let point = imgBase64Str.endsWith("==")?2:(imgBase64Str.endsWith("==")?1:0);
            let size = ((imgBase64Str.length * (3/4) - point) / 1e+6);

            if(size > 3) { // If image Size more than 3MB
              // Resize Image to lower than 3MB
              self.resizeImage(imageData).then(function(result) {
                self.ekycTitle = self.$t('ua-confirm-image');
                self.ekycImageData = result;
                self.hidePreloader();
              });
            } else {
              self.ekycTitle = this.$t('ua-confirm-image');
              self.ekycImageData = imageData;
              self.hidePreloader();
            }
          }, 2000)
        },
        async openCamera() {
          var currentStep = 1;
          var subtitle = this.$t('ua-take-photo-front-doc');
          if(this.currentStep == EkycStep.BACK_DOC_PHOTO) {
            currentStep = 1;
            subtitle = this.$t('ua-take-photo-back-doc');
          } else if(this.currentStep == EkycStep.SELFIE_PHOTO) {
            currentStep = 2;
            subtitle = this.$t('ua-take-photo-selfie-doc');
          } else if(this.currentStep == EkycStep.POA_PHOTO) {
            currentStep = 3;
            subtitle = this.$t('ua-take-photo-poa-doc');
          }

          var totalStep = this.isFromHome?4:3;
          if(!this.isNeedPOA)
            totalStep -= 1;

          let data = JSON.stringify({
            "type": "open_camera",
            "title": '',//this.$t('ua-upload-title'),
            "subtitle": subtitle,
            "currentStep": currentStep,
            "totalStep": totalStep,
            "isFrontCamera": (this.currentStep == EkycStep.SELFIE_PHOTO)
          });

          if(window.Android) {
            window.Android.getWandrCallback(data);
          } else if(window.webkit) {
            window.webkit.messageHandlers.WandrCallbackHandler.postMessage(data);
          }
        },
        choosePhoto() {
          document.getElementById('uploadPhoto').click();
        },
        loadImageFromFile(e) {
          const self = this;
          let file = e.target.files[0];
          if(file) {
            let reader = new FileReader();
            var fileExtension = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
            if (fileExtension.includes(file.name.split('.').pop().toLowerCase()) == false){
                alert("Only '.jpeg','.jpg', '.png', '.gif', '.bmp' formats are allowed.");
            }
            else {
              self.showPreloader();
              reader.onload = (function() {
                return function(e) {
                  // self.hidePreloader();
                  document.getElementById('uploadPhoto').value = "";
                  self.getEKYCImageData(e.target.result, true);
                };
              })(file);
              reader.readAsDataURL(file);
            }
          }
        },
        skipTheStep() {
          this.goToNextStep(true);
        },
        goToNextStep(isSkipTheStep) {
          this.ekycImageData = "";
          if(this.currentStep == EkycStep.NONE) {
            this.currentStep = EkycStep.FRONT_DOC_PHOTO;
          }
          else if(this.isNeedSelfie && (this.currentStep == EkycStep.BACK_DOC_PHOTO || (this.currentStep == EkycStep.FRONT_DOC_PHOTO && this.doc.id == process.env.VUE_APP_DOCUMENT_ID_PASSPORT))) {
            this.currentStep = EkycStep.SELFIE_PHOTO;
          }
          else if(this.currentStep == EkycStep.FRONT_DOC_PHOTO && this.doc.id != process.env.VUE_APP_DOCUMENT_ID_PASSPORT) {
            this.currentStep = EkycStep.BACK_DOC_PHOTO;
          }
          else if(this.currentStep != EkycStep.POA_PHOTO && this.isNeedPOA) {
            this.currentStep = EkycStep.POA_PHOTO;
          }
          else {
            if(this.isFromHome) {
              this.setUpdateIdType({id: this.doc.id, name: this.doc.name});
              this.$f7router.navigate("/verify/personal-detail");
            } else {
              this.ekycList.splice(0, this.ekycList.length); // Remove All EKYC Photo List
              if(this.isFromMyInfo && !this.$store.state.customer.emailverified) { // NEED TO RE-VERIFY EMAIL
                this.$f7router.navigate("/account/email-verify");
              } else if(this.isFromMyInfo) {
                this.$f7router.navigate('/verify/completed');
              } else if(isSkipTheStep) {
                this.$f7router.navigate('/home', {ignoreCache: true, clearPreviousHistory: true});
              } else {
                this.$f7router.navigate('/verify/completed', { props: { isFromEKYC: true }});
              }
            }
            return;
          }

          this.guideImgName = "";
          this.isGuideImgLoaded = false;

          this.Dom7('#ua-take-photo .page-content').scrollTo(0,0);
          this.loadEkycDetail();
          this.showNextSlideAnimation();
        },
        retakeImage() {
          if(this.isChooseFromGallery) {
            this.choosePhoto();
          } else {
            this.openCamera();
          }
        },
        async confirmEkycImage() {
          const self = this;

          // Add Image Data to Array when Image data exists
          // And disable to Upload EKYC Image data doesn't exists
          if(self.ekycImageData != "" && self.ekycImageData.length > 0) {
            self.ekycList.filter(ekyc => ekyc.id == self.docId() && ekyc.stepId == self.currentStep).map(ekyc => ekyc.image = self.ekycImageData);
          } else {
            return;
          }

          // Go To Next Step (Take Photo for Back Docs) when Doc Type is NOT Passport
          if(self.currentStep == EkycStep.FRONT_DOC_PHOTO && self.doc.id != process.env.VUE_APP_DOCUMENT_ID_PASSPORT) {
            self.goToNextStep(false);
            return;
          }

          try{
            self.showPreloader();

            self.$api.ekycService.uploadEkycDocs(self.docId(), "", self.getDocImageList(self.docId())).then(function(result) {
              self.hidePreloader();
              if(result === undefined || result.length <= 0) {
                self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                return false;
              }

              self.$store.state.customer.eKYCDocStatus = process.env.VUE_APP_EKYC_REVIEW_PENDING;
              if(self.currentStep == EkycStep.SELFIE_PHOTO) {
                self.$store.state.customer.eKYCSelfieStatus = process.env.VUE_APP_EKYC_REVIEW_PENDING;
              } else if(self.currentStep == EkycStep.POA_PHOTO) {
                self.$store.state.customer.eKYCPOAStatus = process.env.VUE_APP_EKYC_REVIEW_PENDING;
              } else {
                self.$store.state.customer.eKYCDoc = process.env.VUE_APP_EKYC_REVIEW_PENDING;
              }

              if((result.identificationTypeId == process.env.VUE_APP_DOCUMENT_ID_NATIONAL_ID || result.identificationTypeId == process.env.VUE_APP_DOCUMENT_ID_WORK_PERMIT_D ||
                  result.identificationTypeId == process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID || result.identificationTypeId== process.env.VUE_APP_DOCUMENT_ID_EKYC_WORK_PERMIT_D)/* && doc.issuingCountryId==189 */){
                self.$store.state.customer.eKYCPOAStatus = process.env.VUE_APP_EKYC_REVIEW_PENDING;
              }

              self.goToNextStep(false);
              return true;
            });
          }
          catch(e){
            self.ekycImageData = "";
            self.hidePreloader();
            if(e.message.toLowerCase().includes("undefined")) {
              self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            } else {
              self.$f7.dialog.alert(e.message);
            }
            return false;
          }
        },
        backButton() {
          if(this.ekycImageData != '') {
            this.ekycImageData = "";
          }
          else if(this.currentStep == EkycStep.POA_PHOTO && this.isNeedSelfie) {
            this.currentStep = EkycStep.SELFIE_PHOTO;
          }
          else if((this.currentStep == EkycStep.SELFIE_PHOTO || this.currentStep == EkycStep.POA_PHOTO) && this.doc.id != process.env.VUE_APP_DOCUMENT_ID_PASSPORT) {
            this.currentStep = EkycStep.BACK_DOC_PHOTO;
          }
          else if(this.currentStep != EkycStep.FRONT_DOC_PHOTO) {
            this.currentStep = EkycStep.FRONT_DOC_PHOTO;
          }
          else {
            this.$f7router.back({ transition: 'f7-push' });
            return;
          }

          this.ekycList.filter(ekyc => ekyc.id == this.docId() && ekyc.stepId == this.currentStep).map(ekyc => ekyc.image = "");
          this.guideImgName = "";
          this.isGuideImgLoaded = false;

          this.Dom7('#ua-take-photo .page-content').scrollTo(0,0);
          this.loadEkycDetail();
          this.showPrevSlideAnimation();
        }
    },
    components: {
        ...mapGetters('auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess'
        ])
    },
  }
</script>
